module.exports = __webpack_public_path__ + "img/it-5.5678d8c1.png";